
<script setup>
import {computed, onMounted, ref, toRef, watch} from "vue";
import {useRouter} from "vue-router";
import axios from "@/axios";
import {useLanguageStore} from "@/pinia";
import {formatDate} from "@/plugins/dayjs";
const languageStore = useLanguageStore();
const props = defineProps(['age', 'menu', 'searchDate', 'searchText', 'searchTrigger', 'currentPage']);
const emits = defineEmits(['update:totalPage']);
const meetingData = ref([]);
const router = useRouter();
const age = toRef(props, 'age');
const searchDate = toRef(props, 'searchDate');
const searchText = toRef(props, 'searchText');
const searchTrigger = toRef(props, 'searchTrigger');
const committeeData = ref([]);
const plenaryData = ref([]);


const selectMeeting= (id)=>{
  router.push({
    name : 'detailRecord',
    params : {
      meetingId : id
    }
  })
}
const getData = () => {
  if (age.value == 0) return;

  // 검색 조건 설정
  const searchParams = {
    ageId: age.value,
    meetingType: null,
    meetingLocation: null,
    searchStartDate: null,
    searchEndDate: null,
    searchText: searchText.value || null,
    page: (props.currentPage || 1) - 1,
    size: 10,
    direction: 'DESC',
    properties: ['meetingPreDt']
  };

  // 날짜 검색 조건 설정 (Instant 타입은 UTC 형식 필요)
  if (searchDate.value) {
    searchParams.searchStartDate = searchDate.value + 'T00:00:00Z';
    searchParams.searchEndDate = searchDate.value + 'T23:59:59Z';
  }

  axios.post("/api/meetings/search", searchParams)
    .then(s => {
      plenaryData.value = [];
      committeeData.value = [];
      s.data.content.forEach((meeting) => {
        let meetingTypeId = meeting.meetingType.codeId;
        if (meetingTypeId === 'mt002') plenaryData.value.push(meeting);
        else if (meetingTypeId === 'mt001') committeeData.value.push(meeting);
      });
      meetingData.value = s.data.content;
      emits('update:totalPage', s.data.totalPages);
    }).catch(e => console.log(e));
}
const getColor = (i)=>{
  const colors = ['#D9DEF0', '#EDB8B8']
  //위원회
  if(i == 'mt001') return colors[1] ;
  // 본회의
  else if(i== 'mt002') return colors[0] ;
  else return
}
watch(age, () => {
  getData();
});

watch(searchTrigger, () => {
  getData();
});
watch(() => props.currentPage, () => {
  getData();
});
onMounted(()=>{
  getData()
})
</script>

<template>
  <div class="meetingArea">
    <div class="meetingInfo">
      <div class=""></div>
      <div class="meetingDate">{{languageStore.get('meetingDate')}}</div>
      <div class="meetingTime">{{languageStore.get('openingTime')}}</div>
      <div class="meetingStatus">{{languageStore.get('meetingType')}}</div>
      <div class="meetingName">{{languageStore.get('meetingName')}}</div>
    </div>
    <div class="meetingList">
      <template v-if="menu == 'mt000'">
        <template v-if="meetingData.length > 0 ">
          <template v-for="meeting in meetingData" :key="meeting.meetingId">
            <div><div class="textIcon"  @click="selectMeeting(meeting.meetingId)" :style="{backgroundColor : getColor(meeting.meetingType.codeId)}">{{meeting.meetingType.codeId == 'mt002' ?languageStore.get("plenary") :languageStore.get("committeeShort") }}</div></div>
            <div class="meetingDate"  @click="selectMeeting(meeting.meetingId)">{{formatDate(meeting.meetingPreDt, 'YYYY-MM-DD')}}</div>
            <div class="meetingTime" @click="selectMeeting(meeting.meetingId)">{{formatDate(meeting.meetingPreDt, 'HH:mm')}}</div>
            <div class="meetingStatus" @click="selectMeeting(meeting.meetingId)">{{meeting.meetingType.codeNm}}</div>
            <div class="meetingName" @click="selectMeeting(meeting.meetingId)">{{meeting.age.ageTitle}}_{{meeting.meetingType.codeNm}}{{meeting.committeeId != null ?"_"+meeting.committeeId.codeNm :"" }}</div>
          </template>
        </template>
        <template v-else>
          <div></div>
          <div class="noData">{{languageStore.get('noData')}}</div>
          <div></div>
          <div></div>
          <div></div>
        </template>
      </template>
      <template v-else-if="menu =='mt001'">
        <template v-if="committeeData.length > 1">
          <template v-for="meeting in committeeData" :key="meeting.meetingId">
            <div><div class="textIcon"  @click="selectMeeting(meeting.meetingId)" :style="{backgroundColor : getColor(meeting.meetingType.codeId)}">{{meeting.meetingType.codeId == 'mt002' ?languageStore.get("plenary") :languageStore.get("committeeShort")}}</div></div>
            <div class="meetingDate"  @click="selectMeeting(meeting.meetingId)">{{formatDate(meeting.meetingPreDt, 'YYYY-MM-DD')}}</div>
            <div class="meetingTime" @click="selectMeeting(meeting.meetingId)">{{formatDate(meeting.meetingPreDt, 'HH:mm')}}</div>
            <div class="meetingStatus" @click="selectMeeting(meeting.meetingId)">{{meeting.meetingType.codeNm}}</div>
            <div class="meetingName" @click="selectMeeting(meeting.meetingId)">{{meeting.age.ageTitle}}_{{meeting.meetingType.codeNm}}{{meeting.committeeId != null ?"_"+meeting.committeeId.codeNm :"" }}</div>
          </template>
        </template>
        <template v-else>
          <div></div>
          <div class="noData">{{languageStore.get('noData')}}</div>
          <div></div>
          <div></div>
          <div></div>
        </template>
      </template>
      <template v-else-if="menu == 'mt002'">
        <template v-if="plenaryData.length > 1">
          <template v-for="meeting in plenaryData" :key="meeting.meetingId">
              <div><div class="textIcon"  @click="selectMeeting(meeting.meetingId)" :style="{backgroundColor : getColor(meeting.meetingType.codeId)}">{{meeting.meetingType.codeId == 'mt002' ?languageStore.get("plenary") :languageStore.get("committeeShort")}}</div></div>
              <div class="meetingDate"  @click="selectMeeting(meeting.meetingId)">{{formatDate(meeting.meetingPreDt, 'YYYY-MM-DD')}}</div>
              <div class="meetingTime" @click="selectMeeting(meeting.meetingId)">{{formatDate(meeting.meetingPreDt, 'HH:mm')}}</div>
              <div class="meetingStatus" @click="selectMeeting(meeting.meetingId)">{{meeting.meetingType.codeNm}}</div>
              <div class="meetingName" @click="selectMeeting(meeting.meetingId)">{{meeting.age.ageTitle}}_{{meeting.meetingType.codeNm}}{{meeting.committeeId != null ?"_"+meeting.committeeId.codeNm :"" }}</div>
          </template>
        </template>
        <template v-else>
          <div></div>
          <div class="noData">{{languageStore.get('noData')}}</div>
          <div></div>
          <div></div>
          <div></div>
        </template>
      </template>




<!--      <template v-else>
        <template v-if="meetingData.length >0 ">
          <template v-for="meeting in meetingData" :key="meeting.meetingId">
            <template v-if="meeting.meetingType.codeId == menu">
              <div><div class="textIcon"  @click="selectMeeting(meeting.meetingId)" :style="{backgroundColor : getColor(meeting.meetingType.codeId)}">{{meeting.meetingType.codeId == 'mt002' ?languageStore.get("plenary") :languageStore.get("committeeShort")}}</div></div>
              <div class="meetingDate"  @click="selectMeeting(meeting.meetingId)">{{formatDate(meeting.meetingPreDt, 'YYYY-MM-DD')}}</div>
              <div class="meetingTime" @click="selectMeeting(meeting.meetingId)">{{formatDate(meeting.meetingPreDt, 'HH:mm')}}</div>
              <div class="meetingStatus" @click="selectMeeting(meeting.meetingId)">{{meeting.meetingType.codeNm}}</div>
              <div class="meetingName" @click="selectMeeting(meeting.meetingId)">{{meeting.age.ageTitle}}_{{meeting.meetingType.codeNm}}{{meeting.committeeId != null ?"_"+meeting.committeeId.codeNm :"" }}</div>
            </template>
            <template>aaa</template>
          </template>
        </template>
        <template v-else>
          <div></div>
          <div class="noData">{{languageStore.get('noData')}}</div>
          <div></div>
          <div></div>
          <div></div>
        </template>
      </template>-->


      <!--
      <template v-for="(meeting,i) in meetingData" :key="i">
        <template v-if="menu == '최근회의'">
          <template v-if="meeting.age.ageId == age">
              <div class="meetingDate"  @click="selectMeeting(meeting.meetingId)">{{meeting.meetingPreDt}}</div>
              <div class="meetingTime" @click="selectMeeting(meeting.meetingId)">{{meeting.개의시각}}</div>
              <div class="meetingStatus" @click="selectMeeting(meeting.meetingId)">{{meeting.회의구분}}</div>
              <div class="meetingName" @click="selectMeeting(meeting.meetingId)">{{meeting.회의명}}</div>
          </template>
        </template>
        <template v-else>
          <template v-if="meeting.대수 == age && meeting.회의구분 == menu">
            <div class="meetingDate" @click="selectMeeting(meeting.id)">{{meeting.회의일자}}</div>
            <div class="meetingTime" @click="selectMeeting(meeting.id)">{{meeting.개의시각}}</div>
            <div class="meetingStatus" @click="selectMeeting(meeting.id)">{{meeting.회의구분}}</div>
            <div class="meetingName" @click="selectMeeting(meeting.id)">{{meeting.회의명}}</div>
          </template>
        </template>
      </template>
      -->
    </div>
  </div>
</template>

<style scoped>
  .meetingInfo{
    display: grid;
    grid-template-columns: 2vw 10vw 10vw 10vw 1fr;
    width: 66vw;
    height: 5vh;
    background-color: #f3f3f3;
    color: #052C65;
    font-size: 1.1rem;
    align-items: center;
    justify-items: center;
  }
  .meetingList{
    font-size: 14px;
    display: grid;
    grid-template-columns: 2vw 10vw 10vw 10vw 1fr;
    grid-auto-rows: 6vh;
    width: 65vw;
    height: 100%;
    align-items: center;
    justify-items: center;
  }

  .meetingList div{
    border-bottom: 1px solid #C7C7C7;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .meetingArea{
    height: 80vh;
    display: flex;
    flex-direction: column;
  }
  .noData {
    padding-left: 20px;
    color: #90A4AE;
  }
  .textIcon {
    font-weight: bold;
    color: black;
    max-height:36px;
    max-width: 36px;
    border-radius: 24px;
    border : 1px solid #C7C7C7;
  }
</style>